import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/layout/BrandLogo";
import { SocialLinks } from "@/components/layout/SocialLinks";
import { FOOTER_LINK_ROWS, INDIA_OFFICE } from "@/data/homeContent";
import { INDIA_ROUTES, MAIN_SITE } from "@/lib/mainSiteLinks";

export function Footer() {
  return (
    <footer className="bg-brand-50 text-ink border-t-2 border-brand-100" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 space-y-8">
        <div className="flex flex-col gap-8 border-b-2 border-brand-100 pb-8 lg:flex-row lg:items-start lg:justify-between lg:gap-10">
          <div className="flex min-w-0 flex-row items-center gap-4 sm:gap-5 lg:max-w-xl lg:shrink-0">
            <BrandLogo showTagline={false} tall className="shrink-0" />
            <div className="min-w-0 space-y-2 border-l-2 border-brand-200 pl-4 sm:pl-5">
              <p className="text-sm font-semibold text-ink/70">By UniHawk Education Support Services LLC</p>
              <p className="text-sm leading-relaxed text-ink/80">
                <a href="mailto:info@alearninglab.com" className="font-semibold underline decoration-brand-300 decoration-2 underline-offset-4">
                  info@alearninglab.com
                </a>
                {" · "}
                <a href={`tel:${INDIA_OFFICE.tel}`} className="font-semibold">
                  WhatsApp {INDIA_OFFICE.phone}
                </a>
              </p>
            </div>
          </div>

          <div className="flex min-w-0 flex-1 flex-col gap-2 text-sm font-semibold lg:max-w-md lg:items-end xl:max-w-lg">
            {FOOTER_LINK_ROWS.map((row, rowIndex) => (
              <ul key={rowIndex} className="flex flex-wrap items-center gap-x-4 gap-y-2 lg:justify-end">
                {row.map((link) => (
                  <li key={`${link.href}-${link.label}`}>
                    <a
                      href={link.href}
                      className="inline-flex min-h-[44px] items-center hover:text-brand-600 hover:underline decoration-brand-300 decoration-2 underline-offset-4 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-ink/70">
          <p>© 2026 A Learning Lab by UniHawk. All rights reserved.</p>
          <div className="flex flex-wrap items-center justify-center sm:justify-end gap-4 sm:gap-6">
            <Link to={INDIA_ROUTES.privacy} className="hover:text-brand-600">
              Privacy Policy
            </Link>
            <span className="text-ink/30" aria-hidden="true">
              |
            </span>
            <a href={MAIN_SITE.terms} className="hover:text-brand-600">
              Terms &amp; Conditions
            </a>
            <SocialLinks variant="light" />
          </div>
        </div>
      </div>
    </footer>
  );
}
